import { render, staticRenderFns } from "./ReferalList.vue?vue&type=template&id=6328196a&scoped=true&"
import script from "./ReferalList.vue?vue&type=script&lang=js&"
export * from "./ReferalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328196a",
  null
  
)

export default component.exports